<template>
	<span>
		<!-- <input type="text" class="tbl_int" :value="value" :placeholder="ph" autocomplete="off" style="width:78px;" @input="updateValue" @keyup.enter="search()" /> -->
		<input type="tel" class="tbl_int" :value="value" :placeholder="ph" autocomplete="off" style="width:140px;ime-mode:disabled;" @input="updateValue" @keypress.enter="search($event)" :disabled="disabled" @focus="$event.target.select()" />
		<button @click="selectInvoice()" :disabled="disabled">...</button>

		<Modal @close="closeModal" v-if="showModal && !backOrderMode" :draggable="false">
			<template slot="title">Select Sales Order</template>
			<template slot="body">
				<SoPopup :initialKeyword="value" :initialStatusCode="initialStatusCode" :initialShipToCode="initialShipToCode" :initialFromDaysAgo="initialFromDaysAgo" :link="link" v-on:close="closeModal()" @set-invoice="setInvoice" />
			</template>
		</Modal>
		<Modal @close="closeModal" v-if="showModal && backOrderMode" :draggable="false">
			<template slot="title">Select Sales Order with Back Order</template>
			<template slot="body">
				<BoSoPopup :initialKeyword="value" :initialStatusCode="initialStatusCode" v-on:close="closeModal()" @set-invoice="setInvoice" />
			</template>
		</Modal>
	</span>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import SoPopup from '@/components/common/SoPopup';
import BoSoPopup from '@/components/common/BoSoPopup';
import Modal from '@/components/common/Modal';

export default {
	data: function() {
		return {
			//code: null,
			//name: this.initialName,
			// dl: null,
			// desc: null,
			showModal: false,
		};
	},
	components: {
		SoPopup,
		BoSoPopup,
		Modal,
	},
	props: {
		value: String,
		initialStatusCode: String,
		initialShipToCode: String,
		initialFromDaysAgo: Number,

		ph: String,
		// showName: {
		// 	type: Boolean,
		// 	default: true,
		// },
		// nameWidth: {
		// 	type: Number,
		// 	default: 300,
		// },
		disabled: {
			type: Boolean,
			default: false,
		},
		backOrderMode: {
			type: Boolean,
			default: false,
		},
		link: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		initialName: function(newVal) {
			//console.log(newVal);
			this.name = newVal;
		},
	},
	methods: {
		// onlyAlphabet(e) {
		// 	e.target.value = e.target.value.replace(/[^\\!-z]/gi, '');
		// },
		// handleKeyUp(e) {
		// 	// 대충 특수기호를 제외한 모든것은 지워버린다
		// 	const notPhoneticSymbolExp = /[^bhnwdʒŋjðlɹzɡmvtʃsfkpθɑɛoʊæɝʌɪuɔiae' ]/g;
		// 	if (notPhoneticSymbolExp.test(e.key)) {
		// 		e.target.value = e.target.value.replace(notPhoneticSymbolExp, '');
		// 	}
		// },
		// handleKeydown(e) {
		// 	// 왼쪽, 오른쪽, 백스페이스만 허용
		// 	const whiteList = ['ArrowLeft', 'ArrowRight', 'Backspace'];
		// 	if (!whiteList.some(code => e.code === code)) return;
		// 	if (e.code === 'Backspace') {
		// 		this.deleteSelectedSymbol();
		// 		return;
		// 	}
		// },
		updateValue: function(event) {
			this.$emit('input', event.target.value);
		},
		selectInvoice() {
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		setInvoice(invoice) {
			//console.log('test', invoice);
			// this.name = partner.name;
			this.$emit('input', invoice.so_dn);
			this.$emit('set-invoice', invoice);
		},
		search: function(event) {
			//console.log('test1', event.target.value);
			// this.$emit('input', event.target.value.replace('누', 'SN'));
			// // event.target.value = event.target.value.replace('누', 'SN');
			// console.log('test2', event.target.value);
			const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
			if (reg.exec(event.target.value) !== null) {
				this.$toast.error('Invalid SO Number. Check out Windows IME Mode.');
			} else {
				this.$emit('search');
			}
			//this.$emit('search');
		},
	},
	mounted() {
		inputSelectOnClick();
		//console.log(this.initialShipToCode);
	},
};
</script>

<style></style>
